var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.625H6.04167C5.40073 3.625 4.78604 3.87961 4.33283 4.33283C3.87961 4.78604 3.625 5.40073 3.625 6.04167V22.9583C3.625 23.5993 3.87961 24.214 4.33283 24.6672C4.78604 25.1204 5.40073 25.375 6.04167 25.375H22.9583C23.5993 25.375 24.214 25.1204 24.6672 24.6672C25.1204 24.214 25.375 23.5993 25.375 22.9583V14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2034 3.17264C22.6841 2.69193 23.3361 2.42188 24.0159 2.42188C24.6957 2.42188 25.3477 2.69193 25.8284 3.17264C26.3091 3.65334 26.5792 4.30532 26.5792 4.98514C26.5792 5.66496 26.3091 6.31693 25.8284 6.79764L14.9377 17.6896C14.6508 17.9762 14.2963 18.1861 13.907 18.2998L10.4354 19.3148C10.3315 19.3451 10.2213 19.3469 10.1163 19.32C10.0114 19.2931 9.91565 19.2386 9.83907 19.162C9.76248 19.0854 9.70789 18.9896 9.68101 18.8847C9.65413 18.7798 9.65595 18.6696 9.68628 18.5656L10.7013 15.0941C10.8155 14.705 11.0258 14.351 11.3127 14.0646L22.2034 3.17264Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigEdit);
export default __webpack_public_path__ + "static/media/config-edit.434015960b394dc705950ecb023da78e.svg";
export { ForwardRef as ReactComponent };